/**
 * تصدير CSV يفتحه Excel بالعربى مباشرة.
 *
 * - BOM فى أول الملف: بدونه يقرأ Excel الملف بترميز النظام فيظهر العربى رموزًا.
 * - المبالغ نصوص العقد كما هى (`1250.5000`) لا المنسَّقة بفواصل: Excel يقرؤها أرقامًا
 *   قابلة للجمع، والفاصلة داخل رقم منسَّق كانت ستكسر الأعمدة.
 * - كل خلية تُحاط بعلامتى تنصيص وتُضاعف علاماتها الداخلية، وما يبدأ بـ = + - @
 *   يُسبق بفاصلة عليا حتى لا ينفّذه Excel صيغةً (حقن الصيغ من بيان أدخله مستخدم).
 */
export type CsvCell = string | number | null | undefined;

const FORMULA_START = /^[=+\-@\t\r]/;
const PLAIN_NUMBER = /^-?\d+(\.\d+)?$/;

function cell(value: CsvCell): string {
  if (value === null || value === undefined) return '""';
  let text = String(value);
  // الرقم السالب يبدأ بـ - لكنه ليس صيغة — يبقى رقمًا يجمعه Excel
  if (FORMULA_START.test(text) && !PLAIN_NUMBER.test(text)) text = "'" + text;
  return '"' + text.replace(/"/g, '""') + '"';
}

export function toCsv(header: readonly string[], rows: readonly (readonly CsvCell[])[]): string {
  return '\uFEFF' + [header, ...rows].map((row) => row.map(cell).join(',')).join('\r\n') + '\r\n';
}

export function downloadCsv(
  filename: string,
  header: readonly string[],
  rows: readonly (readonly CsvCell[])[],
): void {
  const blob = new Blob([toCsv(header, rows)], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}
